export function buildHeaders(authorized = true): Record<string, string> {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    if (authorized) {
        headers['Authorization'] = `Bearer ${ localStorage.getItem('auth-token') }`;
    }

    return headers;
}

/** Statuses that mean the backend cannot serve right now, rather than that the request was wrong. */
const UNAVAILABLE_STATUSES = [ 502, 503, 504 ];
const UNAVAILABLE_PAGE = '/503';
const UNAVAILABLE_FROM_KEY = 'unavailable-from';

export function handleExpiredLogin(response: Response): Response {
    if (response.status === 401) {
        console.log("fail path" + window.location.pathname);
        window.location.reload();
    }

    if (UNAVAILABLE_STATUSES.includes(response.status)) showUnavailable();

    return response;
}

/** Leaves for the "service unavailable" page, remembering where to come back to once the backend is up again. */
export function showUnavailable(): void {
    if (window.location.pathname === UNAVAILABLE_PAGE) return;

    sessionStorage.setItem(UNAVAILABLE_FROM_KEY, window.location.pathname + window.location.search);
    window.location.assign(UNAVAILABLE_PAGE);
}

/** The page the user was on when the backend went away, read once. */
export function takeUnavailableFrom(): string | undefined {
    const from = sessionStorage.getItem(UNAVAILABLE_FROM_KEY) ?? undefined;
    sessionStorage.removeItem(UNAVAILABLE_FROM_KEY);

    return from;
}
